module.exports = __webpack_public_path__ + "static/media/logo_nakire_light.03206f3e.png";